// Phase 1.39E — Single source of truth for role → routing.
//
// Canonical roles (backend enum):
//   admin | super_admin | manager | staff | artist
//
// Portal (mobile-first) is ONLY for operational personnel who complete
// appointments and see their own data:   artist, staff
//
// Management panel (admin panel) is for:
//   admin, super_admin, manager
//
// `login_type` (personnel|admin) is an internal RBAC scoping tag — do NOT
// use it for portal routing. Manager users carry `login_type=personnel` for
// ownership scoping but must land in the management panel.

export const PORTAL_ROLES = ["artist", "staff"];
export const MANAGEMENT_ROLES = ["admin", "super_admin", "manager"];

/** True when the user should be routed to `/personel-portal`. */
export function isPortalRole(user) {
  return !!user && PORTAL_ROLES.includes(user.role);
}

/** True when the user should see the admin management panel. */
export function isManagementRole(user) {
  return !!user && MANAGEMENT_ROLES.includes(user.role);
}

/** True when the user is admin/super_admin (excludes manager). */
export function isAdminRole(user) {
  if (!user) return false;
  return user.is_super_admin === true
    || user.role === "admin"
    || user.role === "super_admin";
}

/** Canonical home route for the given user. */
export function homeRouteForUser(user) {
  return isPortalRole(user) ? "/personel-portal" : "/";
}
